import React from 'react';
import classnames from 'classnames';
import PerfectScrollbar from 'react-perfect-scrollbar'
import _ from 'lodash';

import BackButton from './BackButton';
import FilterItem from './FilterItem';
import Icon from '../Icon';

const FiltersSecondaryMenuFilterColor = ({
  i18n,
  show,
  colorPalettes,
  toggleCurrentColor,
  currentColors,
  showFilter,
  setShowFilter,
}) => {
  const filter = 'color';
  const { configurator_filters } = i18n;
  const className = classnames(
    'FiltersSecondaryMenuFilterColor',
    'FiltersSecondaryMenuFilterSection',
    'color',
    { show }
  );

  const handleClick = (id) => { toggleCurrentColor(id); };

  return (
    <div className={classnames(className)}>
      <PerfectScrollbar style={{}} className="container">
        <div className="row mb-2">
          <div className="col-sm-4">
            <div className="d-none">

              <div className="FiltersSecondaryMenuFilterSection__filterImage" />

              <h6 className="FiltersSecondaryMenuFilterSection__filterLabel">
                {configurator_filters[filter]}
              </h6>
            </div>
            <h5 className="FiltersSecondaryMenuFilterSection__filterTitle">
              {configurator_filters[filter]}
            </h5>
          </div>

          <div className="col-sm-8 text-end">
            <BackButton
              showFilter={showFilter}
              setShowFilter={setShowFilter}
            />
          </div>
        </div>

        <div className="row">
          {
            colorPalettes.map(({ name, id, image }, index) => (
              <div className="col-sm-3 my-1" key={id}>
                <FilterItem
                  key={id}
                  id={id}
                  name={name}
                  image={image.thumb.url}
                  onClick={handleClick}
                  active={_.includes(currentColors, id)}
                  className={classnames({
                    'FiltersSecondaryMenuFilterColor__firstItem': index === 0,
                    'FiltersSecondaryMenuFilterColor__secondItem': index === 1,
                  })}
                  compact
                />
              </div>
            ))
          }
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default FiltersSecondaryMenuFilterColor;
